import React, { useCallback } from 'react';
import AppLayout from '../../component/appLayout';
import { Content, HeaderLeft, Heading, Icon, Title } from './style';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import ButtonV2 from '../../component/button/buttonV2';
import ViewsTable from '../../component/viewsTable/viewsTable';
import { useHistory } from 'react-router-dom';
import EmptyState from '../../component/emptyState';
import { useSelector } from 'react-redux';
import viewempty from '../../assets/images/viewempty.png';
import viewdarkempty from '../../assets/images/viewdarkempty.png';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../mobx/rootStore';
import { BUTTON_TYPE } from '../../global/constants';

const Views = observer(() => {
  const getImageSource = () => (themeMode?.theme === 'dark' ? viewdarkempty : viewempty);
  const stateSelector = useSelector((state: RootReducerInterface) => state);
  const { settings: settingsSelector } = stateSelector || {};
  const { themeMode } = settingsSelector;
  const history = useHistory();

  //Mobx store variables
  const { workspaceStore, viewStore } = rootStore;
  const { currentWorkspace } = workspaceStore;
  const { views } = viewStore;

  const onClickNewView = useCallback(() => {
    history.push(`/workspace/${currentWorkspace?.id}/view/new-view`);
  }, [currentWorkspace?.id, history]);

  return (
    <>
      <AppLayout>
        <Content>
          <HeaderLeft>
            <Heading>
              <Icon>
                <SVGIcon
                  name='navbar-views-icon'
                  width='26'
                  height='26'
                  viewBox='0 0 18 18'
                  className='invoice-icon'
                  fill='var(--brand-primary)'
                />
              </Icon>
              <Title>Views</Title>
            </Heading>
          </HeaderLeft>
          {views.length > 0 && (
            <ButtonV2
              title='New view'
              variant={BUTTON_TYPE.PRIMARY}
              onClick={onClickNewView}
              iconName='plus-icon'
              iconPosition='start'
            />
          )}
        </Content>
        {views.length > 0 ? (
          <ViewsTable />
        ) : (
          <EmptyState
            image={getImageSource()}
            header={`No views created yet`}
            title='Create views using filters for the tasks.'
            isGap={20}
            onButtonClick={onClickNewView}
            name='New view'
            isMargin={250}
          />
        )}
      </AppLayout>
    </>
  );
});

export default Views;
